/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCreditDto } from '../../models/backend-credit-dto';
import { BackendCreditRequestDto } from '../../models/backend-credit-request-dto';

export interface FinancingSourcesCreditsCreate$Params {
  body: BackendCreditRequestDto;
}

export function financingSourcesCreditsCreate(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesCreditsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCreditDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesCreditsCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCreditDto>;
    }),
  );
}

financingSourcesCreditsCreate.PATH = '/api/financing_sources/credits/';
